import { types } from "mobx-state-tree";

const ResultCellModel = types.model("ResultCellModel", {
  value: types.maybeNull(types.string),
  isValid: types.optional(types.boolean, false)
});

export default ResultCellModel;